import { useMemo } from 'react';

export type GlowConfig = Record<string, number>;

export const quadratic = (a: number, b: number, c: number, time: number): number => {
    return a * time ** 2 + b * time ** 1 + c;
};

export const linear = ([timeA, outputA]: number[], [timeB, outputB]: number[], time: number): number => {
    const m = (outputB - outputA) / (timeB - timeA);
    const b = outputA - m * timeA;
    return m * time + b;
};

// distance is 0 to 1
// output is 0 to 1
const defaultGlowStrength = (distance: number): number => {
    const k = 0.1;
    return 1 / (1 + (distance / k) ** 2);
};

export const useGlowConfigArray = (
    letterCount: number,
    glowPosition: (time: number) => number,
    glowStrength = defaultGlowStrength,
): GlowConfig[] => {
    /*
     * Don't be mad at this code .. steseide had fun with it
     */
    return useMemo(() => {
        const percentageIncrement = 4;
        const glowMapArray: GlowConfig[] = Array(letterCount)
            .fill(null).map(() => ({}));

        for (let perc = 0; perc <= 100; perc += percentageIncrement) {
            const time = perc / 100; // 0 to 1 on time
            const pos = glowPosition(time); // 0 to 1 on position

            for (let letterIndex = 0; letterIndex < letterCount; letterIndex++) {
                const letterPos = letterCount > 1 ? letterIndex / (letterCount - 1) : 0;
                const distance = Math.abs(pos - letterPos); // 0 to 1 on distance
                const strength = glowStrength(distance); // 0 to 1 on strength
                glowMapArray[letterIndex][`${perc}%`] = strength;
            }
        }

        return glowMapArray;
    }, [letterCount, glowPosition]);
};
